import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Input, Divider } from 'antd';
import AuthShell from './AuthShell';
import { SlackLogo, GoogleLogo } from './logos';
import { requestEmailOtp, goToGoogleSignup, goToSlackLogin } from './authApi';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Enjo-style "Create your account": provider sign-up on top, email below.
const TrooprSignUp = (props) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setError('');
    if (!EMAIL_RE.test(email.trim())) {
      return setError('Please enter a valid email address');
    }
    setLoading(true);
    try {
      const res = await requestEmailOtp(email.trim(), { isSignup: true });
      setLoading(false);
      if (res.data && res.data.success) {
        props.history.push({
          pathname: '/verification',
          state: { sessionId: res.data.sessionId, email: email.trim(), isSignup: true },
        });
      } else {
        setError((res.data && res.data.message) || 'Could not send code. Try again.');
      }
    } catch (e) {
      setLoading(false);
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <AuthShell>
      <h1 className="tpr-auth__title">Create your Troopr account</h1>
      <p className="tpr-auth__subtitle">Use your work email to create your account</p>

      <div className="tpr-auth__providers">
        <Button className="tpr-auth__provider" onClick={goToGoogleSignup}>
          <GoogleLogo /> Sign up with Google
        </Button>
        <Button className="tpr-auth__provider" onClick={goToSlackLogin}>
          <SlackLogo /> Sign up with Slack
        </Button>
      </div>

      <Divider className="tpr-auth__divider">OR continue with</Divider>

      <div className="tpr-auth__field">
        {error && <span className="tpr-auth__error">* {error}</span>}
        <Input
          className="tpr-auth__input"
          placeholder="name@work-email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onPressEnter={submit}
        />
      </div>

      <Button
        className="tpr-auth__primary"
        type="primary"
        loading={loading}
        onClick={submit}
      >
        Continue
      </Button>

      <div className="tpr-auth__footer">
        Already have an account?{' '}
        <span
          className="tpr-auth__link"
          onClick={() => props.history.push('/troopr/access')}
        >
          Sign in
        </span>
      </div>
    </AuthShell>
  );
};

export default withRouter(TrooprSignUp);
